<template>
    <main class="smaller-padding data-table">
        <v-data-table
            :headers="headers"
            :items="list"
            :total-items="30"
            :loading="loading"
            :pagination.sync="sync"
            :hide-actions="true"
            :must-sort="true"
            no-data-text="Sem dados"
            no-results-text="Sem dados"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-monitor-table-item
                    :data-item="props.item"
                ></app-monitor-table-item>
            </template>
        </v-data-table>

        <v-pagination
            v-if="totalPages"
            v-model="sync.page"
            color="primary"
            :length="totalPages"
            :total-visible="7"
            @input="setPage"
        ></v-pagination>
    </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import paginatedTable from "@mixins/paginated-table";
import AppMonitorTableItem from "./components/MonitorTableItem";
import provider from "@mixins/provider";

export default {
    components: {
        AppMonitorTableItem,
    },

    data() {
        return {
            entity: "alertproblem",
            headers: [
                { text: "Tipo", value: "descricaoOrigem" },
                { text: "Origem", value: "entidadeOrigem" },
                { text: "Problema", value: "problema" },
                { text: "Data", value: "data" },
            ],
        };
    },

    mixins: [paginatedTable, provider],

    computed: {},

    methods: {},

    mounted() {
        this.load();
        EventBus.$on("LOAD_MONITOR", this.load);
    },
    beforeDestroy() {
        EventBus.$off("LOAD_MONITOR", this.load);
    },
};
</script>

<style scoped></style>
